<template>
    <div class="button-area form-group">
        <button :class="{ disabled: !isValidForm }" type="submit" class="btn btn-primary btn-save" @click="$emit('save')" v-if="showSaveButton">
            <i class="fa fa-save"/>{{resource('JourneyBuilder_Index_SaveButton_DisplayText')}}
        </button>

        <button :class="{ disabled: !isValidForm }" type="submit" class="btn btn-primary btn-unlock" @click="$emit('unlock')" v-if="showUnlockButton">
            <i class="fa fa-lock"/>{{resource('JourneyBuilder_Shared_UnlockButton_DisplayText')}}
        </button>

        <button class="btn btn-primary ml-2" @click="$emit('clone')" v-if="showCloneButton">
            <i class="fas fa-clone"/> {{resource('JourneyBuilder_Shared_CloneButton_DisplayText')}}
        </button>
    </div>
</template>

<script>

import resources from '@core/Util/Mixins/resources';

export default {
    name: 'menu-controls',
    mixins: [resources],
    props: {
        showSaveButton: {
            type: Boolean,
            default: false
        },
        showUnlockButton: {
            type: Boolean,
            default: false
        },
        showCloneButton: {
            type: Boolean,
            default: false
        },
        isValidForm: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/journey-builder-menu-brick-composer.scss";
</style>
